export default __webpack_public_path__ + "static/media/marauders-map-v3-05-06.34faa2a4.jpg";